import styled from 'styled-components';

import { Divider as BreweryDivider } from '@xing-com/divider';
import { mediaConfined } from '@xing-com/layout-tokens';
import { SeoBreadcrumb as BrewerySeoBreadcrumb } from '@xing-com/seo-breadcrumb';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
} from '@xing-com/tokens';
import {
  Hero as BreweryHero,
  Headline as BreweryHeadline,
} from '@xing-com/typography';

export const Container = styled.div`
  max-width: calc(1400px + 2 * ${spaceL});
  margin: 0 auto;
  padding: 0 ${spaceL} ${space3XL} ${spaceL};
`;

export const SeoBreadcrumb = styled(BrewerySeoBreadcrumb)`
  margin-top: ${spaceXL};
  margin-bottom: 0;

  @media ${mediaConfined} {
    margin-top: ${space4XL};
  }
`;

export const Hero = styled(BreweryHero)`
  margin-top: ${spaceXL};
  margin-bottom: ${spaceXL};

  @media ${mediaConfined} {
    margin-top: ${spaceXL};
    margin-bottom: ${space3XL};
  }
`;

export const Headline = styled(BreweryHeadline)`
  margin-top: ${spaceXXL};
  margin-bottom: ${spaceXL};

  @media ${mediaConfined} {
    margin-top: ${space3XL};
  }

  &:first-of-type {
    margin-top: 0;
  }
`;

export const Divider = styled(BreweryDivider)`
  margin: ${space3XL} 0;
  display: none;

  @media ${mediaConfined} {
    display: block;
  }
`;
